import type { PointerHelp } from '@belong/ai-pointer';

export const YEARLY_WEALTH_DASHBOARD_STRINGS = {
  title: 'Your Home in {year}',
  'title-unit': 'Your Home in {year}, Unit {unitNumber}',
  viewFinancials: 'VIEW FINANCIALS',
  estimatedReturns: 'Est.\nReturn',
  estimatedRoi: 'Est. Rate Of\nReturn (ROI)',
  averageMonthlyCashFlow: 'Avg. Monthly\nCash Flow',
  maintenanceBudget: 'Yearly Maintenance\nEst.',
  byMonth: '/mo.',
  soFar: '{value} So Far',
  vsStock: '{value} vs S&P\u00a0500',
  spentSoFar: '{value} Spent So Far',
};

type HelpValues = { year: number; value?: string };

export const getEstimatedReturnHelp = ({
  year,
  value,
}: HelpValues): PointerHelp => ({
  title: 'How is my return estimated?',
  summary: `Your estimated return for ${year} is **${value}**. We add the rent we expect to collect and the growth in your home's equity and value. Then we subtract your expenses, like fees, insurance, property taxes and maintenance.`,
});

export const getEstimatedRoiHelp = ({
  year,
  value,
}: HelpValues): PointerHelp => ({
  title: 'How is my ROI calculated?',
  summary: `Your estimated rate of return for ${year} is **${value}**. It is your income minus your expenses, divided by **the total you have invested in your home to date**.`,
});

export const getCashFlowHelp = ({ year, value }: HelpValues): PointerHelp => ({
  title: 'What is my cash flow?',
  summary: `Cash flow is the money you can access right away. It is your wealth gains minus unrealized appreciation, averaged over each month of ${year}, which comes to **${value}/mo.** Negative cash flow is a normal part of owning a home while its value grows.`,
});

export const getMaintenanceBudgetHelp = ({
  year,
  value,
}: HelpValues): PointerHelp => ({
  title: 'How is my maintenance budget set?',
  summary: `We expect about **${value}** in maintenance and reconditioning for ${year}. It is based on **your home's value and condition**. It covers both repairs when something breaks and the fixes needed to get your home ready between residents.`,
});
